import { render, staticRenderFns } from "./unidadeCpfMobile.vue?vue&type=template&id=1a5254ac&scoped=true&"
import script from "./unidadeCpfMobile.vue?vue&type=script&lang=js&"
export * from "./unidadeCpfMobile.vue?vue&type=script&lang=js&"
import style0 from "./unidadeCpfMobile.vue?vue&type=style&index=0&id=1a5254ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5254ac",
  null
  
)

export default component.exports